import React, { useState, useEffect } from 'react';

const RiwayatServisForm = ({ existingData, onSave, onCancel }) => {
  const [tanggalServis, setTanggalServis] = useState('');
  const [serviceRutin, setServiceRutin] = useState('');
  const [serviceInsidentil, setServiceInsidentil] = useState('');
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (existingData) {
      setTanggalServis(existingData.tanggalServis ? new Date(existingData.tanggalServis).toISOString().split('T')[0] : '');
      setServiceRutin(existingData.serviceRutin ? existingData.serviceRutin.join(', ') : '');
      setServiceInsidentil(existingData.serviceInsidentil ? existingData.serviceInsidentil.join(', ') : '');
    } else {
      setTanggalServis('');
      setServiceRutin('');
      setServiceInsidentil('');
    }
    setFile(null); // Selalu reset file
  }, [existingData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('tanggalServis', tanggalServis);
    formData.append('serviceRutin', serviceRutin);
    formData.append('serviceInsidentil', serviceInsidentil);
    if (file) {
      formData.append('file', file);
    }
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="form-card">
        <div className="form-group">
            <label>Tanggal Servis</label>
            <input type="date" value={tanggalServis} onChange={(e) => setTanggalServis(e.target.value)} required />
        </div>
        <div className="form-group">
            <label>Service Rutin (pisahkan dengan koma)</label>
            <textarea rows="4" value={serviceRutin} onChange={(e) => setServiceRutin(e.target.value)} placeholder="Contoh: Ganti oli, Cek rem" />
        </div>
        <div className="form-group">
            <label>Servis Insidentil (pisahkan dengan koma)</label>
            <textarea rows="4" value={serviceInsidentil} onChange={(e) => setServiceInsidentil(e.target.value)} placeholder="Contoh: Perbaikan AC" />
        </div>
        <div className="form-group">
            <label>File (PDF, Opsional)</label>
            <input type="file" onChange={(e) => setFile(e.target.files[0])} accept="application/pdf" />
            {existingData && existingData.file && <small>Kosongkan jika tidak ingin mengganti file.</small>}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <button type="button" onClick={onCancel} className="btn-secondary">Batal</button>
            <button type="submit" className="btn-primary">Simpan</button>
        </div>
    </form>
  );
};
export default RiwayatServisForm;